import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import CustomInput from "../../../custom/custom-input/CustomInput";
import { Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";

const SuggestPrice = ({ item, onUpdateData, tenderOrderInfo }) => {
  const [suggestPrice, setSuggestPrice] = useState("");
  const [errorText, setErrorText] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [previousPrice, setPreviousPrice] = useState(0)

  useEffect(() => {
    if (tenderOrderInfo.suggestedPrice) {
      setPreviousPrice(tenderOrderInfo.suggestedPrice); // Устанавливаем предыдущую цену
      setSuggestPrice(""); // Устанавливаем значение в поле равным 0
    } else {
      setSuggestPrice(""); // Если данных нет, тоже 0
    }
  }, [tenderOrderInfo]);



  const handleSuggestPrice = () => {
    const roundedPrice = Math.round(Number(suggestPrice));

    if (!roundedPrice) {
      setErrorText("Введите цену");
      return;
    }
    if (roundedPrice <= 0) {
      setErrorText("Введите корректную положительную цену");
      return;
    }

    setLoading(true);
    setErrorText("");
    setPreviousPrice(roundedPrice)

    Order.suggestedPrice(item.id, { price: roundedPrice })
      .then(() => {
        setLoading(false);
        toast.success("Цена успешно предложена!");
        onUpdateData();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Ошибка при отправке цены:", error);
        setErrorText("Не удалось отправить цену. Попробуйте снова.");
        toast.error("Не удалось отправить цену. Попробуйте снова.");
      });
  };

  return (
      <div className={cn(style.cargo_wrapper)}>
        <div className={cn(style.cargo_title, style.orders_title)}>Предложить цену</div>
        <div style={{display: "flex", paddingBottom: "2px", paddingTop: "2px", width: "100%"}} >
          {previousPrice > 0 && (
              <span>Предыдущая цена: {previousPrice}〒</span>
          )}
        </div>
        <div style={{display: "flex", gap: "16px", width: "100%"}}>
          <CustomInput
              value={suggestPrice}
              isDeleteText
              isBgGray
              inputType="number"
              prefixEnd={<span>〒</span>}
              labelText="Ваша цена"
              placeholder="Введите цену"
              onChangeValue={(value) => setSuggestPrice(value)}
              errorText={errorText}
              style={{flex: "2"}}
          />
          <CustomButton
              text="Предложить цену"
              style={{flex: "1"}}
              onClick={handleSuggestPrice}
              isLoading={isLoading}
          />
        </div>
      </div>
  );
};

export default SuggestPrice;
